<style src="./Burger.scss" lang="scss"></style>

<script>
	import TreeList from '@/components/TreeList/TreeList';
	import { Helper } from '@/services/helper/helper';

	/**
	 * Burger menu in navigation.
	 * @vue-data {boolean} hover If Burger menu is hovered
	 * @vue-data {string | number} timer Timer id for hover state
	 * @vue-data {string} id An unique identifier for the component instance
	 * @vue-data {Object[]} elements An array of objects to fill menu with
	 * @listens Document#click
	 */
	export default {
		name: 'HpBurger',
		data () {
			return {
				hover: false,
				timer: '',
				id: this._uid,
				elements: this.$initialData.burger
			};
		},
		methods: {
			/**
			 * To burger or not to burger: That is the question.
			 * @private
			 */
			toBurgerOrNotToBurger () {
				this.$el.querySelector('label').setAttribute('data-burger', 'true');
				clearInterval(this.timer);
			}
		},
		watch: {
			hover: function (val) {
				if (this.hover) {
					this.timer = setInterval(this.toBurgerOrNotToBurger, 25000);
				} else {
					this.$el.querySelector('label').removeAttribute('data-burger');
					clearInterval(this.timer);
				}
			}
		},
		components: {
			'hp-tree-list': TreeList
		},
		mounted () {
			this.$nextTick(() => {
				document.addEventListener('click', (event) => {
					Helper.uncheckOnOutsideClick(event, this.$el)
				});
			});
		}
	};
</script>

<template>
	<div data-component="burger">
		<input type="checkbox" :id="'burger' + id" data-hidden />
		<label :for="'burger' + id" @mouseenter="hover = true" @mouseleave="hover = false">
			<span></span>
			<span><div></div></span>
			<span></span>
		</label>
		<div data-layer>
			<label data-grid-end-self="" data-close-button="" :for="'burger' + id"><span></span><span></span></label>
			<header>Alle Inhalte</header>
			<nav>
				<ul>
					<hp-tree-list v-for="(element, index) in elements" :key="index" :element="element"></hp-tree-list>
				</ul>
			</nav>
		</div>
	</div>
</template>
